export const errorValidationMessages = {
	required: {
		name: 'Введите пожалуйста имя',
		login: 'Введите пожалуйста логин',
		email: 'Введите Ваш E-mail',
		password: 'Введите пожалуйста пароль',
		repeatPassword: '',
		country: 'Выберите пожалуйста страну',
		region: 'Выберите пожалуйста регион',
		city: 'Введите пожалуйста город',
		feedback: 'Оставьте отзыв',
		username: 'Введите пожалуйста имя пользователя',
		passwordRepeat: 'Повторите пожалуйста пароль',
	},
	requiredSearch: {
		general: 'Введите значение и выберите в выпадающем меню',
	},
	regex: {
		username: '',
		login: '',
		password: 'Пароль должен быть от 8 символов',
		email: '',
		name: '',
	},
	sameAs: {
		passwordRepeat: 'Пароли не совпадают',
	},
};

export const responseMessages = {
	error: 'Ошибка',
	success: {
		login: 'Вы успешно авторизовались',
		register: 'Вы успешно зарегистрировались',
		logout: 'Вы успешно вышли из системы',
		feedback: 'Спасибо за отзыв',
	},
};

const errorMessage = {
	404: 'К сожалению, такой страницы не существует,<br>но есть и другие',
};

export const errorPageMessages = (statusCode?: number) => {
	switch (statusCode) {
		case 404:
			return errorMessage[404];
		default:
			return errorMessage[404];
	}
};
